<i18n lang="yaml">
ru:
  page_title: 'Восстановление пароля'
  password_reset: 'Восстановление пароля'
  enter_email: 'Введите адрес электронной почты, который зарегистрирован у нас на сайте'
  password_reset_button: 'Восстановить пароль'
en:
  page_title: 'Reset password'
  password_reset: 'Reset password'
  enter_email: 'Enter an email registered on our site'
  password_reset_button: 'Reset password'
</i18n>

<template>
  <div class="container login login-reset">
    <h1 v-if="passwordResetText">{{ passwordResetText }}</h1>
    <template v-else>
      <h1>{{ $t('password_reset') }}</h1>
      <form class="form" @submit.prevent="submitForm">
        <span>{{ $t('enter_email') }}</span>
        <field-text v-model="email" :value="email" text="Email" :errors="errors.email" @clear-errors="clearErrors('email')" />
        <button type="submit">{{ $t('password_reset_button') }}</button>
      </form>
    </template>
  </div>
</template>


<script>
import FieldText from '@/components/controls/field-text';

export default {
  components: {
    FieldText,
  },
  middleware: 'auth',
  auth: 'guest',
  data() {
    return {
      email: null,
      errors: {},
      passwordResetText: null,
    }
  },
  head() {
    return {
      title: this.$t('page_title'),
    }
  },
  methods: {
    clearErrors(field) {
      this.errors[field] = [];
    },
    submitForm() {
      this.$axios.$post('/auth/password/reset/', {email: this.email})
        .then((response) => this.passwordResetText = response.detail)
        .catch((e) => {
          try {
            this.errors = e.response.data;
          } catch(e) {
            this.$notify({
              duration: 5000,
              text: this.$t('unknown_error'),
            });
          }
        });
    },
  },
}
</script>
